const videoBlock = {
  el: {
    videoBlocks: <NodeListOf<HTMLElement>>document.querySelectorAll('.video-block'),
    accordionBlocks: <NodeListOf<HTMLElement>>(
      document.querySelectorAll('.accordion-block')
    ),
  },

  init() {
    if (this.el.videoBlocks.length) {
      this.el.videoBlocks.forEach((videoBlock: HTMLElement) => {
        this.handleVideo(videoBlock)
      })
    }

    if (this.el.accordionBlocks.length) {
      this.el.accordionBlocks.forEach((accordionBlock: HTMLElement) => {
        this.handleAccordionVideo(accordionBlock)
      })
    }
  },

  getVideoEmbedUrl(videoUrl: string, autoplay: Number = 1) {
    const youTubeRegex =
      /(http:|https:)?\/\/(www\.)?(m\.)?(youtube.com|youtu.be)\/(watch)?(\?v=)?(\S+)?/
    const vimeoRegex = /^.*(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i

    const youTubeMatch = videoUrl.match(youTubeRegex)
    const vimeoMatch = videoUrl.match(vimeoRegex)

    let http
    let id
    let prefix
    let embedUrl

    if (youTubeMatch) {
      http = youTubeMatch[1]
      id = youTubeMatch[7] // this gets yt video id with all parameters
      id = !id.match(/\?/) ? id.replace(/&/, '?') : id // if id has paramaters but no ?, replace & with ?
      prefix = id.match(/\?/) ? '&' : '?' // for short embeds, if it's just ie. 'https://youtu.be/yR0cJDqMz10' then we need ? to start parameters
      embedUrl = `${http}//www.youtube.com/embed/${id}${prefix}autoplay=${autoplay}&enablejsapi=1`
    } else if (vimeoMatch) {
      http = 'https:'
      id = vimeoMatch[1]
      embedUrl = `${http}//player.vimeo.com/video/${id}?autoplay=${autoplay}`
    }

    return embedUrl
  },

  handleVideo(videoBlock: HTMLElement) {
    const button = <HTMLButtonElement>videoBlock.querySelector('.video-block__button')
    const iframe = <HTMLElement>videoBlock.querySelector('.video-block__iframe')

    const playVideo = () => {
      iframe.setAttribute('src', this.getVideoEmbedUrl(iframe.dataset.videoUrl))
      videoBlock.classList.add('video-block--playing')
    }

    button.addEventListener('click', playVideo)
  },

  handleAccordionVideo(accordionBlock: HTMLElement) {
    const accordionTexts = <NodeListOf<HTMLElement>>(
      accordionBlock.querySelectorAll('.accordion__text')
    )

    accordionTexts.forEach((accordionText: HTMLElement) => {
      accordionText.querySelectorAll('p').forEach((paragraph: HTMLElement) => {
        const videoUrl = this.getVideoEmbedUrl(paragraph.innerHTML, 0)

        if (videoUrl) {
          paragraph.innerHTML = `
            <iframe
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
              frameborder="0"
              class="accordion__video"
              src="${videoUrl}"
            ></iframe>
          `
        }
      })
    })
  },
}

export default videoBlock
